<template>
  <div>
    <base-table-form
      ref="baseForm"
      @input="form => (tableForm = form)"
      v-loading="tableLoading"
      :columns="tableSearchItems"
      :rules="rules"
      @search="tableSearch({ isSelected: '0' })"
    >
      <!-- 其他页面进入不展示 -->
      <el-form-item
        slot="tableActions"
        v-if="!isOpenedByOther && projectType !== 6"
      >
        <!-- 有操作的项目才展示 && 协定服务不是乙方上传 -->
        <template
          v-if="
            hasHandleProject.data &&
              projectDetail.fileUpSource != 1 &&
              projectType !== 21
          "
        >
          <el-button type="primary" plain @click="showCheckLog">
            审核记录
          </el-button>
          <el-button type="primary" @click="quickReview">
            快捷审核
          </el-button>
        </template>
        <!-- 活动维度不展示 -->
        <component
          v-if="showTaskRevoke"
          :is="require('@/page/taskRevoke/button.vue').default"
          :search="tablePageQuery"
        ></component>
        <el-button
          type="primary"
          v-if="!hiddenDownload"
          :disabled="!tableData.length"
          @click="downloadExport"
        >
          下载导出
        </el-button>
        <!-- 协定服务 & 活动维度不展示 -->
        <template v-if="projectType === 19 && homeProject.fileUpMode !== 1">
          <el-button
            type="primary"
            v-if="projectDetail.fileUpSource == 1"
            @click="onAddTask"
          >
            添加任务量
          </el-button>
          <el-button type="primary" @click="onImportData">
            导入结算金额
          </el-button>
        </template>
      </el-form-item>
      <el-form-item slot="tableActions" v-if="!isOpenedByOther">
        <el-button type="primary" @click="handleTaskOverdue">
          任务过期
        </el-button>
      </el-form-item>
    </base-table-form>
    <remarkHinit></remarkHinit>
    <!-- 其他页面进入不展示 -->
    <div class="task-list__actions" v-if="!isOpenedByOther">
      <!-- 不是专区且有操作的项目 -->
      <task-batch-action
        style="padding-bottom: 16px"
        v-if="projectType !== 6 && hasHandleProject.data"
      />
      <is-excess-audit @tableSearch="tableSearch" v-if="showExcessAudit" />
    </div>
    <el-row v-if="hasRepeatPic">
      <el-col :span="24">
        <span>
          <i class="el-icon-warning" style="color: #ff4949"></i>
          <span style="font-weight: 500">图片查重提示：</span>
          <span style="color: #ff4949">*</span>
          标记任务记录内提交的图存在重复，请注意查看
        </span>
      </el-col>
    </el-row>
    <base-table
      ref="baseTableRef"
      :tableColumn="tableColumn"
      :data="tableData"
      :highLightItem="highLightItem"
      v-loading="tableLoading"
      @select-all="selectCurrentPageAll"
      @sort-change="handleSortChange"
      :row-class-name="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
      :defaultSort="defaultSortQuery"
    />
    <el-row type="flex" justify="center">
      <base-table-page
        v-model="tablePageQuery"
        :total="tableTotal"
        :page-sizes="[15, 60, 100]"
        :disabled="tableLoading"
        @change="
          pagination => {
            tableSearch(pagination, 'pagination');
          }
        "
      />
    </el-row>
  </div>
</template>

<script>
import remarkHinit from '../../components/remark-hinit.vue';
import baseTable from '../../components/Base/baseTable';
import request from '@/tools/request';
import taskBatchAction from './task-batch-action';
import createExtend from '@C/createExtend';
import quickReview from '@/page/project-record/views/task-record/task-quick-review';
import operationLog from '@/page/project-record/components/operation-log.vue';
import taskOverdue from '@/page/project-record/components/task-overdue.vue';

import { mapActions, mapState, mapMutations } from 'vuex';
import { auditStatusMapping, recordExportUrl } from '../../static/mapping';
import { makeSure } from '@/tools';
import qs from 'qs';
import { moneyFixed } from '@/tools/money.js';
import openDetail from '../../services/open-detail';
import auditRow from '../../services/audit-row';
import setDefaultQuery from '../../services/set-default-query';
import { auditOssStatus, Task } from '../../api';
import BaseTableForm from '@/page/project-record/components/Base/tableForm';
import BaseTablePage from '@/page/project-record/components/Base/tablePage';
import BaseTableMixin from '@/page/project-record/components/Base/tableMixins';
import IsExcessAudit from '@/page/project-record/components/is-excess-audit.vue';
import AddTask from '../../components/19/add-task'; // ASP 协定服务
import ImportData from '../../components/19/import-data'; // ASP 协定服务
import { aspUpload, editPrice } from '../../services/19'; // ASP 协定服务
import repeatPicture from './repeat-pickure-table';
import newRepeatPickure from './new-repeat-pickure-table.vue';

import { getUnqualifiedRowConfig } from '@/methods/unqualified';

const MAX_SELECTED = 2000; // 最大勾选值

const setDefaultSort = defaultSort => {
  window.sessionStorage.setItem('defaultSort', JSON.stringify(defaultSort));
};

const getDefaultSort = () => {
  const defaultSort = window.sessionStorage.getItem('defaultSort');
  if (defaultSort) return JSON.parse(defaultSort);

  return {};
};

export default {
  name: 'task-list', //任务审核记录
  inject: ['isOpenedByOther', 'otherQuery', 'hasHandleProject'], // isOpenedByOther 是否其他页面跳入或打开。 otherQuery 其他页面传入参数，提交任务中结算数据以组件引入并传入参数。 hasHandleProject {data} true有操作
  provide() {
    return {
      indexPage: this,
      _parent: this
    };
  },
  mixins: [BaseTableMixin],
  components: {
    remarkHinit,
    IsExcessAudit,
    BaseTablePage,
    BaseTableForm,
    // baseForm,
    baseTable,
    // basePagination,
    taskBatchAction,
    AddTask
  },
  data() {
    return {
      getUnqualifiedRowConfig,
      tableLoading: false,
      tableSearchItems: [],
      tableColumn: [],
      rules: {
        dataState: [{ required: true, message: '结算状态必选' }]
      },
      isExcessAudit: false,
      hiddenReviewProgress: false, // 已结算不展示，非可配、问卷不展示，
      highLightItem: '', //点过查看的项
      newRepeatList: {}
    };
  },
  computed: {
    ...mapState('dataAnalysis', ['projectDetail']),
    ...mapState('dataAnalysis/task', [
      'isAll',
      'selectedSize',
      'tableDataRespondQuery'
    ]),
    hasRepeatPic() {
      // 当前是否有重复图片
      return Object.keys(this.newRepeatList).length > 0;
    },
    homeProject() {
      return this.$store.state.homeProject;
    },
    projectType() {
      return this.projectDetail.projectType || +this.$route.query.projectType;
    },
    hiddenDownload() {
      return [1, 2, 3, 7, 8, 9, 10].includes(this.projectType);
    },
    showExcessAudit() {
      return [5, 17, 20].includes(this.projectType);
    },
    showTaskRevoke() {
      return !this.homeProject.fileUpMode !== 1 && this.projectType !== 21;
    },
    ids() {
      return (this.tableData || [])
        .map(item => {
          return item.taskId;
        })
        .join(',');
    },
    defaultSortQuery() {
      return {
        prop: getDefaultSort().prop,
        order: getDefaultSort().order
      };
    }
  },
  watch: {
    selectedSize() {
      this.setHeaderCheckBoxStatus();
    },
    tableData() {
      this.setHeaderCheckBoxStatus();
    },
    'projectDetail.projectId': {
      immediate: true,
      async handler(v) {
        // 列表初始化或者更改了项目
        if (v) {
          this.tableData = [];
          await this.createTable(); // 设置 columns
          this.$refs.baseTableRef.columnsDone(); // columns初始化后
          const params = await this.initDefaultQuery(); // 初始化 参数
          const fortterParams = {};
          // 后端不支持空字段
          Object.keys(params).forEach(pKey => {
            if (params[pKey] !== '') {
              fortterParams[pKey] = params[pKey];
            }
          });
          await this.tableSearch({ ...fortterParams, isSelected: 0 });
        }
      }
    },
    tableSearchQuery: {
      immediate: true,
      handler(v) {
        this.$nextTick(() => {
          // 控制审核进度选项显示
          const reviewProgressDom = document.querySelector('.reviewProgress');
          if (reviewProgressDom && [5, 20].includes(this.projectType)) {
            // 已结算不展示审核进度选项
            reviewProgressDom.style.display =
              v.dataState == 2 ? 'none' : 'block';
          }
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('dataAnalysis/task', ['CLEAR_QUERY_COUNT_TIMER']),
    isNotUnqualified(row) {
      if (row.zbBlackStatus === 2) {
        return false;
      }
      return row.superviseStatus != 3 || row.dataState != 0;
    },
    // 设置当页全选状态
    setHeaderCheckBoxStatus() {
      this.$nextTick(() => {
        // 需要在checkBox组件之后执行
        setTimeout(() => {
          const checkBox = document.querySelector(
            '.el-table__header .el-checkbox__original'
          );
          const parentClassName = checkBox.parentNode.className;
          // 如果当页没有勾选数据，则禁用。根据class判断，防止下一页溢出可进行当页全选
          const isCurrentChecked = ~parentClassName.indexOf('is-checked');
          // >= 2000 && 没有勾选数据，则禁止操作。否则表示当页已全部勾选或者小于2000
          if (
            this.selectedSize + this.tableData.length > MAX_SELECTED &&
            !isCurrentChecked
          ) {
            if (!~parentClassName.indexOf('is-disabled')) {
              checkBox.parentNode.className = parentClassName + ' is-disabled';
              checkBox.disabled = 'disabled';
            }
          } else {
            checkBox.parentNode.className = parentClassName.replace(
              'is-disabled',
              ''
            );
            checkBox.disabled = '';
          }
        });
      });
    },
    /**
     * @description: 搜索，分页
     * @param {object} param 接口参数
     * @param {string} type 区分是否需要初始化列表。 init初始分页（如搜索），pagination 分页标识。
     */
    tableSearch(param, type = 'init') {
      let q = null;
      if (type === 'init') {
        q = { ...this.tableSearchQuery };
      }
      if (type === 'pagination') {
        //表格响应数据的 query 全选多选用到

        // 切换 分页要保持相同请求参数 搜索表单的值 要与实际请求数据结果的入参一致
        const { form } = this.$refs.baseForm;
        Object.keys(form).forEach(k => {
          form[k] = this.tableDataRespondQuery[k];
        });

        q = { ...this.tableDataRespondQuery };
      }

      // 混合以组件调用时传入的参数
      Object.assign(q, {
        ...(this.otherQuery &&
          this.otherQuery.statementId && {
            statementId: this.otherQuery.statementId,
            dataState: this.otherQuery.dataState
          })
      });
      if (param) {
        Object.assign(q, param);
      }
      if (this.projectType === 6) {
        Object.assign(q, {
          dataState: 0
        });
      }
      // 处理点击搜索后没有重置分页
      // this.tablePageQuery.pageNo !== 1 防止tablePage组件再次emit导致两次调用
      // param判断为了防止pageNo改为1。场景：详情操作后需刷新当前页数据时。
      if (type === 'init' && this.tablePageQuery.pageNo !== 1 && param) {
        this.tablePageQuery.pageNo = 1;
        this.tablePageQuery.isSelected = 0; // isSelected 仅在搜索时为0，后续都为1
        return;
      }

      // 排序字段处理
      const sortVal = getDefaultSort();
      if (Object.keys(sortVal).length > 0) {
        const sortOrder = {
          [sortVal.prop + 'Order']: sortVal.order
        };
        Object.assign(q, sortOrder);
      }

      this.tableLoading = true;
      this.getList(q)
        .then(res => {
          const { list, total } = res;
          this.tableData = JSON.parse(JSON.stringify(list));
          this.tableTotal = total;
          return res;
        })
        .then(({ query }) => {
          // 用户标签 字符串形式
          if (query.userTag && Array.isArray(query.userTag)) {
            if (query.userTag.includes('未设置')) {
              query.notSet = 1;
            }
            query.userTag = query.userTag.join(',');
          }
        })
        .finally(() => {
          this.tableLoading = false;
          this.tablePageQuery.isSelected = 1;
          this.findRepeatImg();
        });
    },
    findRepeatImg() {
      const ids = this.ids;
      let projectId =
        this.projectDetail.projectId ||
        this.$route.query.projectId ||
        this.$route.query.id;
      if (ids.length > 0) {
        if (projectId) {
          Task.findSimiForList({
            ids,
            projectId
          }).then(({ pdata }) => {
            this.newRepeatList = pdata;
          });
        } else {
          setTimeout(() => {
            Task.findSimiForList({
              ids,
              projectId
            }).then(({ pdata }) => {
              this.newRepeatList = pdata;
            });
          }, 10);
        }
      }
    },
    ...mapActions('dataAnalysis/task', ['getList']),
    downloadExport() {
      if (!this.tableData.length) {
        this.$alert('当前没有可下载的任务记录', {
          type: 'warning'
        });
        return;
      }
      const {
        projectId,
        projectType,
        projectStructureType
      } = this.projectDetail;
      const exportQuery = {
        ...this.tableSearchQuery,
        projectId,
        projectType,
        notSet: this.tableSearchQuery.userTag == '未设置' ? 1 : 0,
        userType: projectStructureType === 2 ? 2 : 1 // 1、3为1 ，2为2
      };
      const query = `?taskType=${this.projectType}&${qs.stringify(
        exportQuery
      )}`;
      //如果是调研问卷和数字问卷就去下载中心下载
      if ([5, 21].includes(+projectType)) {
        request
          .post('/rest/cso/saas/exportTaskCenter', {
            taskType: this.projectType,
            ...exportQuery
          })
          .then(() => {
            this.$alert('操作成功，请前往下载中心查看！', {
              type: 'success'
            });
          });
        return;
      }
      const downloadUrl = `${recordExportUrl[this.projectType]}${query}`;
      makeSure(this.$downloadFile.bind(this, downloadUrl, true, '', 'post'));
    },
    /**
     *
     * @param isSelected 是否选中数据 1是 0否
     * @returns {Promise<void>}
     */
    async selectCurrentPageAll(isSelected) {
      const taskIds = this.tableData
        .filter(
          i => i.auditStatus == 1 && i.isItOperable && i.superviseStatus != 3
        )
        .map(i => i.taskId);
      if (taskIds.length < 1) {
        this.$notify({
          title: '失败',
          message: '暂无可操作数据！',
          type: 'error'
        });
        return;
      }

      const params = {
        isDelete: isSelected ? '0' : '1', //0新增 1 取消
        taskIds: taskIds,
        projectId: this.projectDetail.projectId
      };

      await request
        .post('/rest/cso/saas/taskRecord/taskRecordListAll/edit', params, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          notUseQs: true
        })
        .then(res => {
          this.$store.commit(
            'dataAnalysis/task/SET_SELECTED_SIZE',
            res.data.data.selectedSize
          );
        });
      const q = {
        ...this.tableDataRespondQuery,
        isSelected: '1'
      };
      this.getList(q)
        .then(res => {
          const { list, total } = res;
          this.tableData = list;
          this.tableTotal = total;
          const q1 = JSON.parse(JSON.stringify(q));
          if (q1.userTag && typeof q1.userTag === 'string') {
            q1.userTag = q1.userTag.split(',');
          }
          setTimeout(() => {
            for (const k in q1) {
              this.$refs.baseForm.form[k] = q1[k];
            }
          });
          return res;
        })
        .then(({ query }) => {
          // 用户标签 字符串形式
          if (query.userTag && Array.isArray(query.userTag)) {
            if (query.userTag.includes('未设置')) {
              query.notSet = 1;
            }
            query.userTag = query.userTag.join(',');
          }
        })
        .then(() => {
          this.findRepeatImg();
        });
    },
    quickReview() {
      createExtend(quickReview, {
        projectId: this.projectDetail.projectId,
        type: this.projectDetail.type,
        isOpenedByOther: this.isOpenedByOther
      });
    },
    repeatPicture(row) {
      createExtend(repeatPicture, {
        projectId: this.projectDetail.projectId,
        sceneType: this.projectDetail.projectType,
        currentTaskId: row.taskId,
        isOpenedByOther: this.isOpenedByOther
      });
    },
    newRepeatPickure(row) {
      createExtend(newRepeatPickure, {
        projectId: this.projectDetail.projectId,
        taskId: row.taskId,
        isOpenedByOther: this.isOpenedByOther
      }).$on('parentRefresh', () => {
        this.tableSearch();
      });
    },
    showCheckLog() {
      this.$router.push({
        name: 'taskCheckLog',
        query: {
          projectId: this.projectDetail.projectId,
          type: this.projectDetail.type
        }
      });
    },
    // 其他页面进入无搜索，操作只有查看详情
    createTable() {
      return new Promise(resolve => {
        const vm = this;
        const { projectType, fileUpMode, fileUpSource } = this.homeProject;
        //协定服务活动形式的
        const showActivity =
          +projectType === 19 && (+fileUpMode === 1 || fileUpSource === 3);
        // 数字拜访
        const isDigitalVisit = +projectType === 17;

        let tableSearchItems = [
          {
            type: 'daterange',
            fieldKeys: ['finishDtStart', 'finishDtEnd'],
            hidden: this.projectType === 6,
            label: '', //提交时间
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '提交开始时间',
            'end-placeholder': '提交结束时间',
            pickerOptions: {
              shortcuts: [
                {
                  text: '本月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date(end.getFullYear(), end.getMonth());
                    picker.$emit('pick', [start, end]);
                  }
                }
              ],
              disabledDate(date) {
                return date >= new Date();
              }
            }
          },
          {
            type: 'daterange',
            fieldKeys: ['visitDtStart', 'visitDtEnd'],
            hidden: !+vm.projectDetail.showVisitDt,
            label: '', //拜访时间
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '拜访开始时间',
            'end-placeholder': '拜访结束时间',
            pickerOptions: {
              shortcuts: [
                {
                  text: '本月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date(end.getFullYear(), end.getMonth());
                    picker.$emit('pick', [start, end]);
                  }
                }
              ],
              disabledDate(date) {
                return date >= new Date();
              }
            }
          },
          {
            type: 'input',
            label: '', //项目参与人
            fieldKey: 'userName',
            placeholder: '项目参与人'
          },
          {
            type: 'input',
            label: '', //个体名
            fieldKey: 'userEnterpriseName',
            placeholder: '个体名',
            hidden: this.projectDetail.projectStructureType !== 2
          },
          {
            type: 'input',
            label: '', //手机号
            fieldKey: 'phone',
            placeholder: '手机号'
          },
          {
            width: '600px',
            placeholder: '人员标签',
            fieldKey: 'userTag',
            type: 'autocomplete',
            maxLength: 30,
            hidden: +this.homeProject.fileUpMode === 1, //有活动不展示
            querySearch: (queryString, cb) => {
              cb(
                [{ value: '未设置' }].filter(
                  i => i.value.indexOf(queryString) > -1
                )
              );
            }
          },
          {
            type: 'input',
            label: '', //任务编码
            hidden: this.projectType === 6,
            fieldKey: 'taskCode',
            placeholder: '任务编码'
          }
        ];
        if (!this.isOpenedByOther) {
          Array.prototype.push.apply(tableSearchItems, [
            {
              type: 'select',
              label: '', //服务商状态
              hidden: this.projectType === 6,
              placeholder: '服务商状态',
              fieldKey: 'auditStatus',
              options: [
                { label: '未提交审核', value: '0' },
                { label: '审核中', value: '1' },
                { label: '审核通过', value: '2' },
                { label: '审核未通过', value: '3' }
                // { label: '审核中', value: 5 }
              ]
            },
            {
              type: 'select',
              label: '', //平台状态
              hidden: this.projectType === 6,
              placeholder: '平台状态',
              fieldKey: 'auditOssStatus',
              options: [
                { label: '未提交审核', value: '0' },
                { label: '审核中', value: '1' },
                { label: '审核通过', value: '2' },
                { label: '审核未通过', value: '3' }
              ]
            },
            {
              type: 'input',
              label: '',
              hidden: !showActivity,
              fieldKey: 'activityName',
              placeholder: '活动名称'
            },
            {
              type: 'select',
              label: '', //工业状态
              hidden: this.projectType === 6,
              placeholder: '工业状态',
              fieldKey: 'auditGongyeStatus',
              options: [
                { label: '未提交审核', value: '0' },
                { label: '审核中', value: '1' },
                { label: '审核通过', value: '2' },
                { label: '审核未通过', value: '3' }
              ]
            },
            {
              type: 'select',
              label: '', //结算状态
              hidden: this.projectType === 6,
              placeholder: '结算状态',
              fieldKey: 'dataState',
              clearable: false,
              options: [
                { label: '未结算', value: '0' },
                { label: '结算中', value: '1' },
                { label: '已结算', value: '2' }
              ]
            },
            {
              type: 'select',
              label: '', //是否过期
              hidden: this.projectType === 6,
              placeholder: '是否过期',
              fieldKey: 'isOverdue',
              options: [
                { label: '未过期', value: '0' },
                { label: '已过期', value: '1' }
              ]
            },
            {
              type: 'select',
              hidden: ![5, 20].includes(this.projectType),
              placeholder: '审核进度',
              fieldKey: 'reviewProgress',
              class: 'reviewProgress',
              clearable: false,
              options: [
                { label: '未完成', value: '0' },
                { label: '已完成', value: '1' }
              ]
            }
            // {
            //   type: 'select',
            //   placeholder: '是否可结算',
            //   fieldKey: 'superviseStatus',
            //   options: [
            //     {
            //       label: '全部',
            //       value: 0
            //     },
            //     {
            //       label: '可结算',
            //       value: 1
            //     },
            //     {
            //       label: '不可结算',
            //       value: 2
            //     }
            //   ]
            // }
          ]);
        }
        this.tableSearchItems = tableSearchItems;
        // 如果是园区
        this.tableColumn = [
          {
            prop: 'taskId',
            type: 'selection',
            resizable: false,
            width: '60px',
            fixed: 'left',
            hidden:
              !!this.isOpenedByOther ||
              this.projectType === 6 ||
              this.projectType === 21,
            inputChange: function(v, row) {
              const { taskId, projectId } = row;
              //调 单个打对勾接口
              return new Promise((resolve, reject) => {
                request
                  .post(
                    '/rest/cso/saas/taskRecord/taskRecordListAll/edit',
                    {
                      projectId: projectId,
                      taskIds: [taskId],
                      isDelete: v ? '0' : '1' // 0表示需要新增，1表示删除
                    },
                    {
                      headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                      },
                      notUseQs: true
                    }
                  )
                  .then(res => {
                    const {
                      data: {
                        code,
                        data: { selectedSize }
                      }
                    } = res;
                    if (+code === 1) {
                      vm.$store.commit(
                        'dataAnalysis/task/SET_SELECTED_SIZE',
                        selectedSize
                      );
                      row.isSelected = v ? '1' : '0';
                      return resolve();
                    } else {
                      return reject();
                    }
                  });
              });
            },
            disabled: function(row) {
              if (row.superviseStatus == 3) {
                return true;
              }
              return (
                row.auditStatus !== 1 ||
                (vm.selectedSize >= MAX_SELECTED && row.isSelected == '0') || // 最多可选2000个
                [0].includes(row.isItOperable) // 0不可操作
              );
            }
          },
          {
            type: 'index',
            label: '序号',
            width: '65px',
            resizable: false,
            fixed: 'left',
            render: (h, { row, scope }) => {
              const _this = this;
              const hasRepeatPicIds = Object.keys(_this.newRepeatList);
              const isHasRepeatPic = hasRepeatPicIds.includes(
                String(row.taskId)
              );
              return (
                <div>
                  {
                    // +row.isPicRepeat == 1 &&
                    // [5, 20].includes(_this.projectDetail.projectType) && (
                    //   <img
                    //     onClick={() => {
                    //       _this.repeatPickure(row);
                    //     }}
                    //     style="cursor:pointer;width:20px;"
                    //     src={require('@/assets/重复报警.png')}
                    //   />
                    // )
                  }
                  {isHasRepeatPic && (
                    <img
                      src={require('@/assets/重复报警.png')}
                      style="cursor:pointer;width:20px;"
                      onClick={() => {
                        _this.newRepeatPickure(row);
                      }}
                      type="text"
                    />
                  )}
                  <span>{scope.$index + 1}</span>
                </div>
              );
            }
          },
          {
            prop: 'userName',
            resizable: false,
            label: function() {
              return '项目参与人';
            },
            width: '150'
          }, // : "张三",//项目参与人
          {
            prop: 'userEnterpriseName',
            label: '个体',
            resizable: false,
            hidden: vm.projectDetail.projectStructureType !== 2
          }, // : "" , //个体
          { prop: 'phone', resizable: false, label: '手机号' },
          {
            prop: 'userTag',
            resizable: false,
            label: '人员标签',
            hidden: +fileUpMode === 1, //有活动不展示
            render(h, { row }) {
              return <span>{row['userTag'] || '未设置'}</span>;
            }
          },
          {
            prop: 'industryEnterpriseName',
            label: '客户企业',
            resizable: false,
            hidden: vm.projectType !== 6
          },
          {
            prop: 'passUv',
            resizable: false,
            label: '点击数(UV)',
            hidden: vm.projectType !== 6
          },
          // {
          //   prop: 'passUv',
          //   resizable: false,
          //   label: '过期任务量',
          //   hidden: vm.projectType !== 6
          // },
          {
            prop: 'csoPrice',
            resizable: false,
            label: '终端结算单价',
            width: '150',
            hidden: vm.projectType !== 6,
            formatter: ({ val }) => moneyFixed(val)
          },
          {
            prop: 'activityName',
            resizable: false,
            label: '关联活动',
            hidden: !showActivity,
            render(h, { row }) {
              if (!vm.isOpenedByOther) {
                return (
                  <el-link
                    onClick={() => {
                      vm.$router.replace({
                        query: {
                          activeTask: 'activeList',
                          t: Date.now(),
                          activityName: row.activityName,
                          projectId: vm.projectDetail.projectId
                        }
                      });
                    }}
                    type="primary"
                  >
                    {row.activityName || '-'}
                  </el-link>
                );
              } else {
                return <span>{row.activityName || '-'}</span>;
              }
            }
          },
          {
            prop: 'taskPrice',
            resizable: false,
            label: '任务单价',
            hidden: vm.projectType !== 19,
            formatter: ({ val }) => moneyFixed(val)
          },
          {
            prop: 'taskId',
            resizable: false,
            label: '审核进度',
            hidden: [6, 19].includes(vm.projectType), // 数字专区，协定服务没有该项
            render: function(h, { row }) {
              return h(
                'div',
                {
                  style: {
                    color:
                      row.passTaskSum >= row.residueTaskSum ? 'red' : '#67c23a'
                  }
                },
                `${row.passTaskSum || 0}/${row.residueTaskSum || 0}`
              );
            }
          },
          {
            prop: 'taskCode',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '任务编码'
          }, // : "xxxxxxxxxx" , //任务编码
          {
            prop: 'finishDt',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '提交时间',
            type: 'sortable',
            width: '150px',
            sortable: 'custom'
          }, // : "2021-09-11" , //提交时间
          {
            prop: 'visitDt',
            resizable: false,
            hidden: !+vm.projectDetail.showVisitDt,
            label: '拜访时间',
            type: 'sortable',
            width: '150px',
            sortable: 'custom',
            formatter: ({ row }) => {
              // 数字拜访特殊处理
              if (isDigitalVisit) {
                return row.visitDt;
              } else {
                if (row.visitDtStart && row.visitDtEnd) {
                  return row.visitDtStart + ' ~ ' + row.visitDtEnd;
                } else {
                  return '-';
                }
              }
            }
          }, // : "2021-09-11" , //拜访时间 数字拜访和可配置展示
          {
            prop: 'auditStatus',
            resizable: false,
            label: '服务商状态',
            width: '150',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, //ASP审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过  5 审核中（重新提交）
          {
            prop: 'csoAuditUser',
            resizable: false,
            label: '服务商审核人',
            width: '150',
            hidden:
              !vm.homeProject.isAuditCso || // 宏宏判断了其他场景 0是不展示 1展示
              (+vm.projectType === 19 && // 协定服务
                vm.homeProject.fileUpSource === 1), // 1ASP上传
            formatter: ({ val }) => {
              return val || '-';
            }
          },
          {
            prop: 'auditOssStatus',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '平台状态',
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, // OSS审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过
          {
            prop: 'auditGongyeStatus',
            resizable: false,
            hidden:
              vm.projectType === 6 ||
              !vm.projectDetail.industryEnterpriseId ||
              vm.projectDetail.industryEnterpriseId == -1,
            label: '工业状态',
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, //工业审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过
          {
            prop: 'isOverdue',
            resizable: false,
            label: '是否过期',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return ['未过期', '已过期'][val];
            }
          }, // : 0, //是否过期  0 未过期(默认)  1 已过期
          {
            prop: 'dataState',
            resizable: false,
            label: '结算状态',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return ['未结算', '结算中', '已结算'][val];
            }
          }, // : 1 ,//结算状态  0未结算 1结算中 2已结算
          {
            label: '操作',
            resizable: false,
            width: vm.isOpenedByOther ? '100px' : '250px',
            hidden: !!vm.isOpenedByOther,
            fixed: 'right',
            render: function(h, { row }) {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      size: 'mini'
                      // disabled: +row.auditStatus !== 1
                    },
                    on: {
                      click: function() {
                        vm.highLightItem = row.taskId; //点击了该项的查看则把任务id替换【集合仅代表用户当前查看的任务】
                        openDetail({
                          isOpenedByOther:
                            !!vm.isOpenedByOther || !vm.hasHandleProject.data, // 其他页面打开或者没有操作的项目
                          auditApi:
                            '/rest/cso/saas/taskRecord/info/auditOssStatus',
                          row,
                          tableSearchQuery: vm.tableSearchQuery,
                          projectDetail:
                            vm.$store.state.dataAnalysis.projectDetail,
                          getList: vm.tableSearch.bind(this)
                        });
                      }
                    }
                  },
                  '查看'
                ),
                h(
                  'el-button',
                  {
                    style: `display: ${
                      !vm.isOpenedByOther &&
                      vm.projectType === 19 &&
                      !showActivity
                        ? 'inline-block'
                        : 'none'
                    }`,
                    props: {
                      type: 'text',
                      size: 'mini',
                      disabled: row.superviseStatus == 3
                      // disabled: +row.auditStatus !== 1
                    },
                    on: {
                      click: function() {
                        editPrice(row, vm.tableSearch);
                      }
                    }
                  },
                  '编辑金额'
                ),
                h(
                  'el-button',
                  {
                    style: `display: ${
                      !vm.isOpenedByOther &&
                      vm.projectType === 19 &&
                      vm.projectDetail.fileUpSource == 1 &&
                      !showActivity
                        ? 'inline-block'
                        : 'none'
                    }`,
                    props: {
                      type: 'text',
                      size: 'mini',
                      disabled: row.superviseStatus == 3
                      // disabled: +row.auditStatus !== 1
                    },
                    on: {
                      click: function() {
                        aspUpload(vm.projectDetail, row, vm.tableSearch);
                      }
                    }
                  },
                  '上传附件'
                ),
                h(
                  'el-button',
                  {
                    style: `display: ${
                      vm.isOpenedByOther ||
                      vm.projectType === 6 ||
                      !vm.hasHandleProject.data
                        ? 'none'
                        : 'inline-block'
                    }`,
                    props: {
                      type: 'text',
                      size: 'mini',
                      disabled:
                        row.superviseStatus == 3 ||
                        row.auditStatus != 1 ||
                        row.isItOperable === 0 ||
                        row.isItOperable === 2 // 此条数据是否可以操作 通过 不通过，0否1是2超额
                    },
                    on: {
                      click: function() {
                        auditRow({
                          ajax: auditOssStatus,
                          params: {
                            auditStatus: 2,
                            taskId: row.taskId,
                            ...vm.$store.state.dataAnalysis.projectDetail
                          },
                          getList: vm.tableSearch.bind(),
                          auditStatus: 2
                        });
                      }
                    }
                  },
                  '通过'
                ),
                h(
                  'el-button',
                  {
                    style: `display: ${
                      vm.isOpenedByOther ||
                      vm.projectDetail.projectType === 6 ||
                      !vm.hasHandleProject.data
                        ? 'none'
                        : 'inline-block'
                    }`,
                    props: {
                      type: 'text',
                      size: 'mini',
                      disabled:
                        row.superviseStatus == 3 ||
                        row.auditStatus != 1 ||
                        row.isItOperable === 0 // "isItOperable" : 0 ,// 此条数据是否可以操作 通过 不通过，0否1是 如果不能操作，则此数据只能查看，其余操作都不可
                    },
                    on: {
                      click: async function() {
                        auditRow({
                          ajax: auditOssStatus,
                          params: {
                            auditStatus: 3,
                            taskId: row.taskId,
                            ...vm.$store.state.dataAnalysis.projectDetail
                          },
                          getList: vm.tableSearch.bind(this),
                          auditStatus: 3
                        });
                      }
                    }
                  },
                  '不通过'
                )
                // h(
                //   'el-button',
                //   {
                //     style: `display: ${
                //       vm.isOpenedByOther || vm.projectDetail.projectType === 6
                //         ? 'none'
                //         : 'inline-block'
                //     }`,
                //     props: {
                //       type: 'text',
                //       size: 'mini'
                //     },
                //     on: {
                //       click: function() {
                //         createExtend(operationLog, {
                //           projectId: vm.projectDetail.projectId,
                //           projectType: vm.projectDetail.projectType,
                //           taskId: row.taskId
                //         });
                //       }
                //     }
                //   },
                //   '操作日志'
                // )
              ]);
            }
          }
        ];

        this.createTableId = setTimeout(resolve());
      });
    },
    initDefaultQuery() {
      return new Promise(resolve => {
        const { form } = this.$refs.baseForm;
        form.isOverdue = '0'; // 默认选择未过期  0：未过期 1：已过期
        let defaultQuery = setDefaultQuery(
          this.otherQuery || this.$route.query,
          this.projectDetail
        );
        Object.assign(form, defaultQuery);
        this.initDefaultQueryId = setTimeout(resolve(form));
      });
    },
    async searchTheList() {
      await this.createTable(); // 设置 columns
      await this.initDefaultQuery(); // 初始化 参数
      await this.$refs.baseForm.validate(); // 验证字段
      await this.tableSearch(); // 请求列表接口
    },
    onAddTask() {
      this.$xrkDialog({
        showConfirm: false,
        showCancel: false,
        title: '添加任务量',
        width: '800px',
        $slots: {
          default: this.$createElement(AddTask, {})
        }
      });
    },
    onImportData() {
      this.$xrkDialog({
        showConfirm: false,
        showCancel: false,
        title: '导入提交',
        width: '600px',
        $slots: {
          default: this.$createElement(ImportData, {
            props: { tableSearchQuery: this.tableSearchQuery },
            on: {
              success: () => {
                this.tableSearch();
              }
            }
          })
        }
      });
    },
    handleSortChange({ prop, order }) {
      setDefaultSort({ prop, order });
      this.tableSearch();
    },
    // 任务过期
    handleTaskOverdue() {
      createExtend(taskOverdue, {
        projectId: this.projectDetail.projectId,
        projectType: this.projectDetail.projectType,
        tableSearchItems: this.tableSearchItems,
        tableColumn: this.tableColumn,
        isOpenedByOther: this.isOpenedByOther,
        otherQuery: this.otherQuery
      });
    }
  },
  destroyed() {
    clearTimeout(this.createTableId);
    clearTimeout(this.initDefaultQueryId);
    this.CLEAR_QUERY_COUNT_TIMER();
  }
};
</script>
<style scoped lang="scss">
@import '~@/styles/mixin';

.task-list__actions {
  @include flex_jc_ai;
}
</style>
